import { CampaignWorkflowFormState } from './CampaignWorkflowFormState';

export const CampaignWorkflowFormInitialState: CampaignWorkflowFormState = {
  touched: {},
  focused: {},
  errors: {},
  validationResults: [],
};
